import { useAgentChatPageCreation } from './useAgentChatPageCreation';
import { createRecommendationTrackingWrapper } from './createRecommendationTrackingWrapper';
import { MessageDisplay } from '../../types/chat-hook-types';

/**
 * Page creation with recommendation tracking
 * Auto-generated using the standardized factory pattern
 * Now supports both temporary and database IDs for reliability
 */
export const useAgentChatPageCreationWithTracking = (message: MessageDisplay | string) => {
  // Apply tracking wrapper
  const trackingWrapper = createRecommendationTrackingWrapper(
    useAgentChatPageCreation,
    'page',
    {
      // Simplified metadata for private page tracking (no project dependencies)
      getMetadata: (params, result) => ({
        pageTitle: params.page?.title || 'Private Page',
        pageType: params.page?.type || 'Other',
        pageDescription: params.page?.description || ''
        // No workbookId - private page
      }),
      // Use the page ID from the result
      getSavedItemId: (result) => result.id
    }
  );
  
  return trackingWrapper(message);
}; 